module.exports = __webpack_public_path__ + "img/undraw_completed_tasks_vs6q.9c8674cf.svg";